<template>
  <div class="home">
    <div class="common-layout">
      <el-container>
        <el-header class="common-header">
          <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect">
            <span style="line-height: 45px; font-size: 20px; margin-right: 40px"
            >客服系统</span
            >
            <!-- <el-menu-item index="1">系统首页</el-menu-item>
            <el-menu-item index="2">客户管理</el-menu-item> -->
          </el-menu>
          <div class="wzgg">
            <span>网站公告：</span>
            <el-tag class="gg_item" type="success">{{ notice }}</el-tag>
          </div>
          <div class="yyname">
            <el-tooltip
                :content="userStore.userInfo.hospitalName"
                class="box-item"
                effect="dark"
                placement="left">
              <span style="font-size: 13px">{{
                  userStore.userInfo.hospitalName
                }}</span>
            </el-tooltip>
          </div>
          <div class="user_item">
            <el-dropdown>
              <div class="user_photo">
                <el-avatar :size="40" :src="circleUrl" />
                <span>{{ userStore.userInfo.userName }}</span>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="updateUser()"
                  >修改资料</el-dropdown-item
                  >
                  <el-dropdown-item @click="exitLogin()"
                  >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
        <el-container>
          <el-aside width="200px">
            <el-menu
                :key="menuKey"
                :default-active="menuDefaultActive"
                class="el-menu-vertical-demo"
                @close="handleClose"
                @open="handleOpen">
              <el-menu-item
                  v-for="item in menuIndex"
                  :key="item.index"
                  :index="item.index">
                <span class="el_menu_span" @click="menuClick(item)">{{
                    item.name
                  }}</span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main class="common-main">
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </div>

    <el-dialog v-model="alterPasswordDialog" title="修改密码" width="300">
      <el-form ref="ruleFormRef" :model="alterPasswordForm" :rules="rules">
        <el-form-item
            :label-width="formLabelWidth"
            label="原密码"
            prop="oldPassword">
          <el-input
              v-model="alterPasswordForm.oldPassword"
              autocomplete="off" />
        </el-form-item>
        <el-form-item
            :label-width="formLabelWidth"
            label="新密码"
            prop="newPassword">
          <el-input
              v-model="alterPasswordForm.newPassword"
              autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="alterPasswordDialog = false">关闭</el-button>
          <el-button type="primary" @click="alterPassword()"> 提交 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { useUserStore } from "@/store/counter";
import { alter_user_password } from "@/http/api.js";
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
//const { Bus } = getCurrentInstance().appContext.config.globalProperties;
const route = useRoute();
const userStore = useUserStore();
const router = useRouter();
const activeIndex = ref("1");
const ruleFormRef = ref();
const menuDefaultActive = ref(1);
const alterPasswordDialog = ref(false);
const alterPasswordForm = ref({});
const circleUrl = ref(
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
);
const notice = ref(
    "1.多个问题 分开提交；2.已处理问题如不满意可以退回，不需要重复提交"
);
const menuIndex = ref([
  {
    index: "1",
    route: "glyQuestionTable",
    name: "所有问题",
  },
  {
    index: "2",
    route: "glyQuestionTable",
    name: "待处理",
  },
  {
    index: "3",
    route: "glyQuestionTable",
    name: "已处理",
  },
  {
    index: "4",
    route: "glyQuestionTable",
    name: "稍后处理",
  },
  {
    index: "5",
    route: "htgl",
    name: "后台管理",
  },
  {
    index: "6",
    route: "questionTable",
    name: "医院问题",
  },
  {
    index: "7",
    route: "questionTable",
    name: "医院问题-已处理",
  },
  {
    index: "8",
    route: "questionTable",
    name: "医院问题-待处理",
  },
  {
    index: "9",
    route: "questionTable",
    name: "医院问题-稍后处理",
  },
]);
const rules = ref({
  oldPassword: [
    { required: true, message: "请输入原密码", trigger: "blur" },
    { min: 6, max: 18, message: "长度在 6 到 18 个字符", trigger: "blur" },
  ],
  newPassword: [
    { required: true, message: "请输入新密码", trigger: "blur" },
    { min: 6, max: 18, message: "长度在 6 到 18 个字符", trigger: "blur" },
  ],
});

const menuKey = ref(0);

onMounted(() => {
  initMenu();

  if (route.name == "home") {
    sessionStorage.setItem("menuIndex", "1");
    if (userStore.userInfo.roleId == "9") {
      router.push("/questionTable");
    } else {
      router.push("/glyQuestionTable");
    }
  }
  menuDefaultActive.value = sessionStorage.getItem("menuIndex");
});
function initMenu() {
  if (userStore.userInfo.roleId == "9") {
    // 院方
    menuIndex.value = [
      {
        index: "1",
        route: "questionTable",
        name: "医院问题",
      },
      {
        index: "2",
        route: "questionTable",
        name: "医院问题-已处理",
      },
      {
        index: "3",
        route: "questionTable",
        name: "医院问题-待处理",
      },
      {
        index: "4",
        route: "questionTable",
        name: "医院问题-稍后处理",
      },
    ];
  } else if (userStore.userInfo.roleId == "1") {
    menuIndex.value = [
      {
        index: "1",
        route: "glyQuestionTable",
        name: "所有问题",
      },
      {
        index: "8",
        route: "glyQuestionTable",
        name: "当日处理",
      },
      {
        index: "2",
        route: "glyQuestionTable",
        name: "待处理",
      },
      {
        index: "3",
        route: "glyQuestionTable",
        name: "已处理",
      },
      {
        index: "4",
        route: "glyQuestionTable",
        name: "稍后处理",
      },
      {
        index: "5",
        route: "htgl",
        name: "后台管理",
      },
      {
        index: "6",
        route: "tjwt",
        name: "提交问题",
      },
      {
        index: "7",
        route: "cxtj",
        name: "查询统计",
      },
    ];
  } else if (userStore.userInfo.roleId == "2") {
    menuIndex.value = [
      {
        index: "1",
        route: "glyQuestionTable",
        name: "所有问题",
      },
      {
        index: "8",
        route: "glyQuestionTable",
        name: "当日处理",
      },
      {
        index: "2",
        route: "glyQuestionTable",
        name: "待处理",
      },
      {
        index: "3",
        route: "glyQuestionTable",
        name: "已处理",
      },
      {
        index: "4",
        route: "glyQuestionTable",
        name: "稍后处理",
      },
      {
        index: "5",
        route: "tjwt",
        name: "提交问题",
      },
      {
        index: "6",
        route: "cxtj",
        name: "查询统计",
      },
    ];
  } else if (userStore.userInfo.roleId == "5") {
    menuIndex.value = [
      {
        index: "1",
        route: "glyQuestionTable",
        name: "所有问题",
      },
      {
        index: "8",
        route: "glyQuestionTable",
        name: "当日处理",
      },
      {
        index: "2",
        route: "glyQuestionTable",
        name: "待处理",
      },
      {
        index: "3",
        route: "glyQuestionTable",
        name: "已处理",
      },
      {
        index: "4",
        route: "glyQuestionTable",
        name: "稍后处理",
      },
      {
        index: "6",
        route: "tjwt",
        name: "提交问题",
      },
    ];
  } else {
    menuIndex.value = [
      {
        index: "1",
        route: "glyQuestionTable",
        name: "所有问题",
      },
      {
        index: "8",
        route: "glyQuestionTable",
        name: "当日处理",
      },
      {
        index: "2",
        route: "glyQuestionTable",
        name: "待处理",
      },
      {
        index: "3",
        route: "glyQuestionTable",
        name: "已处理",
      },
      {
        index: "4",
        route: "glyQuestionTable",
        name: "稍后处理",
      },
      {
        index: "5",
        route: "tjwt",
        name: "提交问题",
      },
    ];
  }
}
function menuClick(item) {
  sessionStorage.setItem("menuIndex", item.index);
  router.push({
    name: item.route,
    query: {
      index: item.index,
    },
  });
}
function updateUser() {
  alterPasswordDialog.value = true;
}
function alterPassword() {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.validate((valid, fields) => {
    if (valid) {
      const account = userStore.userInfo.userAccount;
      const oldPassword = alterPasswordForm.value.oldPassword;
      const newPassword = alterPasswordForm.value.newPassword;
      alter_user_password(account, oldPassword, newPassword).then((res) => {
        if (res.code == 200) {
          alterPasswordDialog.value = false;
          ElMessage.success(res.message);
        } else {
          ElMessage.error(res.message);
        }
      });
    }
  });
}
function exitLogin() {
  userStore.logout();
  router.push("/login");
}

onBeforeUnmount(() => {
  sessionStorage.setItem("menuIndex", "1");
});

//Bus.on("questionSubmit", () => {
// console.log("触发了监听");
// menuKey.value++;
//});
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
}
.common-main {
  padding: 0px;
  height: calc(100vh - 66px);
  background-color: #f4f4f5;
}
.common-header {
  height: 50px;
  display: flex;
  border-bottom: 0.4px solid #cccccc;
}
.el-menu-demo {
  height: 50px;
  width: 35%;
}
.el_menu_span {
  width: 100%;
  height: 100%;
  font-size: 18px;
  font-weight: 1000;
}
.wzgg {
  height: 50px;
  width: 45%;
  line-height: 40px;
}
.yyname {
  width: 20%;
  line-height: 40px;
}
.user_item {
  // height: 50px;
  // display: flex;
  margin-right: -20px;
  min-width: 190px;
  overflow: visible; /* 或者使用 'hidden', 'scroll', 'auto' */
  .user_photo {
    line-height: 40px;
    display: flex;
    align-items: center;
    gap: 10px; /* 调整间隔 */
  }
}
.table_input {
  float: left;
  margin-top: -15px;
  margin-bottom: 10px;
  .table_input_span {
    margin-left: 10px;
    font-size: 14px;
  }
}
.router-link-active {
  text-decoration: none;
  color: #000;
}
a {
  text-decoration: none;
  color: #000;
}
</style>

<style>
.el-menu-item.is-active {
  color: #409eff; /* 选中状态下的字体颜色 */
  background-color: #ecf5ff; /* 选中状态下的背景颜色 */
}
</style>
